import clsx from 'clsx'

type SpinnerSize = 'sm' | 'md' | 'lg'

interface SpinnerProps {
  size?: SpinnerSize
  className?: string
}

const sizeMap: Record<SpinnerSize, string> = {
  sm: 'w-4 h-4 border-2',
  md: 'w-8 h-8 border-[3px]',
  lg: 'w-12 h-12 border-4',
}

export default function Spinner({ size = 'md', className }: SpinnerProps) {
  return (
    <div className={clsx(
      'rounded-full border-brand-200 border-t-brand-600 animate-spin',
      sizeMap[size],
      className,
    )} />
  )
}
